/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets SDPrimaryRIDPResponseStruct from api:
 * /v1/ua/primary_RIDP
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchPrimaryRIDPUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/primary_RIDP`,
    models.SDPrimaryRIDPResponseStruct
  );
};

/**
 * Post request to path:
 * /v1/ua/secondary_RIDP
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSecondaryRIDPUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/secondary_RIDP`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewSDSecondaryRIDPResponseStructResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Gets SDFARSResponseStruct from api:
 * /v1/ua/fars_response
 *
 * @param {string} dshReferenceNumber.
 * @param {any} callback function to call once this function has finished
 */
const fetchFarsResponseUtil = (dshReferenceNumber, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/fars_response?dshReferenceNumber=${dshReferenceNumber}`,
    models.SDFARSResponseStruct
  );
};

/**
 * Post request to path:
 * /v1/ua/complete_FARs
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postCompleteFARsUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/complete_FARs`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Post request to path:
 * /v1/ua/rba_RIDP
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postRbaRIDPUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/rba_RIDP`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.SDRIDPResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/getRecord_response
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postGetRecordResponseUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/getRecord_response`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.SDGetRecordResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export {
  fetchPrimaryRIDPUtil,
  postSecondaryRIDPUtil,
  fetchFarsResponseUtil,
  postCompleteFARsUtil,
  postRbaRIDPUtil,
  postGetRecordResponseUtil,
};
